import {
    SkyNetSpreadSheetCellType,
    SkyNetSpreadSheetConfigType,
} from 'app/shared-components/SkyNetSpreadSheet'
import {
    AdditionalFeesConfigParams,
    getCommonAdditionalFeesFields,
    createSpreadsheetConfig,
} from 'app/Apps/Rates/components/AdditionalFeesSpreadsheet/AdditionalFeesSpreadsheet.config'

import {
    AdditionalFeesTable,
} from '../AdditionalFees.types'

export default function getAdditionalFeesConfig(
    params: AdditionalFeesConfigParams,
): SkyNetSpreadSheetConfigType<keyof AdditionalFeesTable> {
    const commonFields = getCommonAdditionalFeesFields(params)

    const simplifiedCQuoteField = {
        name: 'simplifiedCQuoteDescription' as const,
        title: params.getLabel('LaneFeesRateCard.simplifiedCQuoteDescription'),
        width: 250,
        required: true,
        cellConfig: {
            type: SkyNetSpreadSheetCellType.TEXT,
        },
    }

    // Insert simplifiedCQuoteDescription after productType (index 3)
    const fields = [
        ...commonFields.slice(0, 3),
        simplifiedCQuoteField,
        ...commonFields.slice(3),
    ]

    return createSpreadsheetConfig(fields)
}
